import { FolderType } from 'utils/api/modules/entities/entities.types';

export type { FolderType, FoldersResponse } from 'utils/api/modules/entities/entities.types';

// Values double as the reorder endpoint's payload keys.
export enum FolderTreeItemKind {
  Folder = 'folders',
  Document = 'documents',
}

export interface FlattenedTreeItem {
  uuid: string;
  kind: FolderTreeItemKind;
  parentUuid: string | null;
  depth: number;
}
